<template>
    <div id="ChannelForwardSetting">
        <div class="departman-card">
            <div class="mode-card">
                <div class="title">{{ $t('message.departmentForwardEnable') }}
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        :checked="!!channel.forward.department"
                        @click="toggleDepartmentForwardingRule"
                    />

                </div>
                <div class="subtitle">{{ $t('message.departmentForwardDesc') }}</div>
                <div v-if="channel.forward.department">
                    <a-select
                        v-model="channel.forward.department"
                        :defaultValue="null"
                        notFoundContent="👉 Forward Live Agents"
                        style="width: 100%; margin-top: 10px"
                    >
                        <a-select-option
                            v-if="!handleDepartmentChange(channel.forward.department)"
                            :selected="true"
                            :value="null"
                        >
                            👉 Forward Live Agents
                        </a-select-option>
                        <a-select-option
                            :key="department._id"
                            v-for="department in departments"
                            :value="department._id"
                        >
                            {{ getDepartmentTitle(department) }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
        </div>
        <div class="mode-card-content">
            <div class="mode-card" style="max-height: 150px">
                <div class="title">{{ $t('message.liveFabListDescription') }}
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        v-model="liveMode"
                        @change="handleLiveSupportModeChange"
                    />
                </div>
                <div class="subtitle">{{ $t('message.AssignMessagesToAgents') }}</div>
            </div>
            <div class="mode-card" style="max-height: 150px">
                <div class="title">
                    {{ $t('chatbotv2.chatbot') }}
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        v-model="chatbotMode"
                        @change="handleChatbotModeChange"
                    />
                </div>
                <div class="subtitle">{{ $t('message.firstChatbotAndAssign') }}</div>
                <div v-if="chatbotMode">
                    <a-select
                        v-model="channel.forward.story"
                        :defaultValue="null"
                        notFoundContent="👉 Forward Live Agents"
                        style="width: 100%; margin-top: 10px"
                    >
                        <a-select-option
                            v-if="!checkHaveChatbotStory(channel.forward.story)"
                            :selected="true"
                            :value="null"
                        >
                            👉 Forward Live Agents
                        </a-select-option>
                        <a-select-option
                            :key="story._id"
                            v-for="story in stories"
                            :value="story._id"
                        >
                            {{ story.title }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="mode-card">
                <div class="title">
                    {{ $t('report.hybrid') }}
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        v-model="hybridChatMode"
                        @change="handleHybridModeChange"
                    />
                </div>
                <div class="subtitle">{{ $t('message.hybridAssign') }}
                </div>
                <div v-if="channel.forward.mode === 'hybrid'" style="margin-top: 5px">
                    <div>
                        <b style="font-size:11px">({{ $t('message.checkDepartmentToAgent') }})</b>
                        <a-select
                            v-model="channel.forward.hybrid.department"
                            :defaultValue="null"
                            notFoundContent="👉 Forward Live Agents"
                            style="width: 100%;"
                        >
                            <a-select-option
                                :selected="true"
                                :value="null"
                            >
                                All Departments
                            </a-select-option>
                            <a-select-option
                                :key="department._id"
                                v-for="department in departments"
                                :value="department._id"
                            >
                                {{ getDepartmentTitle(department) }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div>
                        <b style="font-size:11px">({{ $t('message.ifAllOfflineStory') }})</b>
                        <a-select
                            v-model="channel.forward.story"
                            :defaultValue="null"
                            notFoundContent="👉 Forward Live Agents"
                            style="width: 100%;"
                        >
                            <a-select-option
                                v-if="!checkHaveChatbotStory(channel.forward.story)"
                                :selected="true"
                                :value="null"
                            >
                                👉 Forward Live Agents
                            </a-select-option>
                            <a-select-option
                                :key="story._id"
                                v-for="story in stories"
                                :value="story._id"
                            >
                                {{ story.title }}
                            </a-select-option>
                        </a-select>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
    name: "ChannelForwardSetting",
    props: {
        channel: {
            type: Object,
            default: () => ({}),
            required: true,
        },
        isDepartmentForwarding: {
            type: Boolean,
            default: false,
        },
        isChatbotSwitch: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            liveMode: this.channel.forward.mode === "live",
            chatbotMode: this.channel.forward.mode === "chatbot",
            hybridChatMode: this.channel.forward.mode === "hybrid",
            hybridDepartment: null,
            hybridModeVisibility: false,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            departments: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
    },
    methods: {
        toggleDepartmentForwardingRule() {
            if (!!this.channel.forward.department) {
                this.channel.forward.department = null;
            } else {
                if (this.departments[0]) {
                    this.channel.forward.department = this.departments[0]._id;
                }
            }
            this.channel = _.cloneDeep(this.channel);
        },
        checkHaveChatbotStory(id) {
            return this.stories.find((story) => story._id === id);
        },
        handleLiveSupportModeChange(value) {
            this.liveMode = value;
            if (value) {
                this.chatbotMode = false;
                this.hybridChatMode = false;
                this.channel.forward.story = null;
            }
            this.channel.forward.mode = value ? "live" : "";
        },
        handleChatbotModeChange(value) {
            this.chatbotMode = value;
            if (value) {
                this.liveMode = false;
                this.hybridChatMode = false;
            }
            this.channel.forward.mode = value ? "chatbot" : "";
        },
        handleHybridModeChange(value) {
            this.hybridModeVisibility = true;
            this.hybridChatMode = value;
            if (value) {
                this.liveMode = false;
                this.chatbotMode = false;
            }
            this.channel.forward.mode = value ? "hybrid" : "";
        },
        handleDepartmentChange(id) {
            return this.departments.find((story) => story._id === id);
        },
        getDepartmentTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
    },

};
</script>
<style lang="scss" scoped>
#ChannelForwardSetting {
    margin-top: 20px;

    .departman-card {
        margin-bottom: 20px;
    }

    .mode-card-content {
        display: flex;
        gap: 20px;
        justify-content: space-between;
    }
    .mode-card {
        width: 100%;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        background-color: #fff;

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
            display: flex;
            justify-content: space-between;
            padding-bottom: 10px;
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }

    }
}

</style>
